@if (visible) {
  <div #overlayMenuWrapper>
    <div class="absolute z-20 w-full bg-white dark:bg-dark-card px-4 py-4 rounded-md flex flex-col border border-gray-300 dark:border-dark-border shadow-md max-h-96 overflow-y-auto">
      @if (collection && collection.length === 0) {
        <div class="flex font-normal text-secondary">
          {{ 'search.results.noresults' | translate }}
        </div>
      } @else {

        @for (item of flattenedResults; track i; let i = $index) {
          @if (item.isCategory) {
            <div class="flex">
              <div class="rounded-md bg-gray-100 dark:bg-dark-hover text-xs text-gray-500 dark:text-dark-muted py-2 px-2">{{ item.category | translate }}</div>
            </div>
          } @else {
            <div class="ml-4 pt-4 border-l border-l-gray-100 dark:border-l-dark-border pl-4">
              <a
                class="flex flex-col font-normal text-secondary dark:text-dark-muted bg-white dark:bg-dark-card ease-in-out duration-200 rounded-md py-3 px-3 mb-2 hover:bg-gray-100 dark:hover:bg-dark-hover hover:text-primary dark:hover:text-dark-text"
                [ngClass]="{ '!border-none !bg-gray-100 dark:!bg-dark-hover': focusItem === i }"
                (click)="$event.preventDefault(); emitClick(item)"
                href="#"
                tabindex="-1"
                #listItem
              >
                @if (Array.isArray(item.title)) {
                  @for (title of item.title; track titleIndex; let titleIndex = $index) {
                    <div
                    [ngClass]="{'text-sm': titleIndex > 0}"
                    [innerHTML]="title | highlight: searchQuery"></div>
                  }
                } @else {
                  <div [innerHTML]="item.title | highlight: searchQuery"></div>
                }
              </a>

            </div>
          }
        }
      }
    </div>
  </div>
}
